export default "__VITE_ASSET__CJpE8hFD__"